import React from 'react';

import { NoDataBoundary } from '@/shared/ui/NoDataBoundary';

import styles from './FeaturesTab.module.css';

type FeaturesTabProps = {
  mlModelFqn?: string;
  isLoading?: boolean;
};

const FeaturesTabComponent: React.FC<FeaturesTabProps> = () => {
  return (
    <div className={styles.featuresTab}>
      <NoDataBoundary data={[]} emptyDescription="사용 가능한 기능 데이터가 없습니다">
        <div />
      </NoDataBoundary>
    </div>
  );
};

export const FeaturesTab = React.memo(FeaturesTabComponent);
